import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { getLanguage } from "../utils/local-storage";
import { REACT_APP_DEFAULT_LANG, REACT_APP_ENV } from "../config";
const defaultLang = getLanguage() || REACT_APP_DEFAULT_LANG;

i18n.use(initReactI18next).init({
  resources: {
    vi: {
      translation: require("./locales/vi.json"),
    },
  },
  lng: defaultLang, // Ngôn ngữ mặc định
  fallbackLng: "vi", // Ngôn ngữ dự phòng nếu không tìm thấy dịch
  interpolation: {
    escapeValue: false, // Bật hoặc tắt xử lý đặc biệt trong chuỗi dịch
  },
  debug: REACT_APP_ENV === "development",
});

export default i18n;
